














import PopupCircleEpisode from '@/views/templates/kuntama/PopupCircleEpisode.vue'

export default
  components: {
    PopupCircleEpisode
  }

  data: () ->
    message: [
      '燻らのたまごに興味を持ってくれてありがとう。'
      'おいしい燻製たまごが食べたくなったら'
      'またいつでもおいで！'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    addPoint: (point) ->
      @$emit('addPoint', point)
  }
